export default {"src":"/_next/static/media/logo-bright.f0dc46e0.svg","height":156,"width":131,"blurWidth":0,"blurHeight":0};